export default "__VITE_ASSET__e204ad04__"